<div class="info-panel"  #infoPanel
     [style.top]="top" [style.left]="left"
     [style.min-height.px]="model.minHeight? model.minHeight:100">
    <div class="header" *ngIf="model.title">
        <div class="title">
            {{model.title}}
        </div>
        <bd-fa-button [name]="'times'" *ngIf="model.showCloseBtn" (click)="onCloseBtnClicked()"></bd-fa-button>
    </div>
    <div class="message-container">
            <div *ngFor="let message of model.messages">{{message}}</div>
    </div>
</div>
